export default __webpack_public_path__ + "static/media/bulk.7ee280e0.svg";